import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementGooglepayBlackIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<g clipPath="url(#clip0_7626_46357)">
				<path
					d="M11.344 11.88V14.646H10.444V7.806H12.783C13.353 7.806 13.893 8.014 14.313 8.401C14.733 8.758 14.943 9.293 14.943 9.858C14.943 10.423 14.733 10.929 14.313 11.315C13.893 11.702 13.383 11.91 12.783 11.91L11.344 11.88ZM11.344 11.018H12.844C13.174 11.018 13.504 10.899 13.714 10.661C14.194 10.215 14.194 9.472 13.744 9.025L13.714 8.995C13.474 8.757 13.174 8.608 12.844 8.638H11.344V11.018ZM17.012 9.828C17.672 9.828 18.182 10.006 18.572 10.363C18.962 10.72 19.142 11.196 19.142 11.79V14.645H18.302V13.991H18.272C17.912 14.526 17.402 14.794 16.802 14.794C16.202 14.794 15.842 14.645 15.482 14.348C15.152 14.051 14.942 13.634 14.942 13.188C14.942 12.742 15.122 12.326 15.482 12.028C15.842 11.731 16.352 11.612 16.952 11.612C17.552 11.612 17.912 11.701 18.242 11.909V11.701C18.242 11.404 18.122 11.106 17.882 10.928C17.642 10.72 17.342 10.601 17.012 10.601C16.502 10.601 16.112 10.809 15.842 11.226L15.062 10.75C15.542 10.126 16.173 9.828 17.012 9.828ZM15.873 13.218C15.873 13.456 15.993 13.664 16.173 13.783C16.383 13.932 16.623 14.021 16.863 14.021C17.223 14.021 17.583 13.872 17.853 13.605C18.153 13.337 18.303 13.01 18.303 12.653C18.033 12.445 17.643 12.326 17.133 12.326C16.623 12.326 16.473 12.415 16.233 12.594C15.993 12.743 15.873 12.95 15.873 13.218ZM24 9.977L21.031 16.727H20.131L21.241 14.378L19.292 10.007H20.252L21.662 13.367H21.692L23.072 10.007H24.002V9.977H24Z"
					fill="currentColor"
				/>
				<path
					d="M7.77507 11.285C7.77507 11.017 7.74507 10.75 7.71507 10.482H3.96607V11.999H6.09507C6.00507 12.475 5.73507 12.921 5.31507 13.188V14.169H6.60507C7.35507 13.485 7.77507 12.475 7.77507 11.285Z"
					fill="currentColor"
				/>
				<path
					d="M3.96601 15.121C5.04601 15.121 5.94507 14.764 6.60507 14.169L5.31507 13.188C4.95507 13.426 4.50501 13.575 3.96501 13.575C2.94501 13.575 2.04601 12.891 1.74601 11.939H0.427007V12.95C1.11701 14.288 2.46601 15.121 3.96601 15.121Z"
					fill="currentColor"
				/>
				<path
					d="M1.74702 11.939C1.56702 11.463 1.56702 10.928 1.74702 10.422V9.41101H0.427017C-0.142983 10.511 -0.142993 11.82 0.427007 12.95L1.74702 11.939Z"
					fill="currentColor"
				/>
				<path
					d="M3.93305 8.817C4.50305 8.817 5.04305 9.025 5.46305 9.412L6.60305 8.282C5.88305 7.628 4.92405 7.241 3.96405 7.271C2.46405 7.271 1.08505 8.104 0.425054 9.442L1.74505 10.453C2.01505 9.50101 2.91505 8.817 3.93405 8.817H3.93305Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7626_46357">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

PaiementGooglepayBlackIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementGooglepayBlackIcon;
